import React, {useCallback, useReducer, useState} from 'react';
import Header from './header/Header';
import Footer from './footer/Footer';

import MaterialColor from './material_color/MaterialColor';
import Create from './create/Create';
import Extract from './extract/Extract';
import Harmonize from './harmonize/Harmonize';
import Saved from './saved/Saved';

import {getCache, setCache} from '../../utils/utils';
import Settings from '../comms/Settings';

const readSettingsState = () => ({
   material_color: getCache().material_color,
   solid: getCache().solid,
   gradient: getCache().gradient,
   complement: getCache().complement,
   split: getCache().split,
   analogous: getCache().analogous,
   triadic: getCache().triadic,
   tetradic: getCache().tetradic,
   solgrad: getCache().solgrad,
   extraction: getCache().extraction,
   harmony: getCache().harmony,
   preset: getCache().preset,
   extraction_count: getCache().extraction_count,
});

const settingsReducer = (state, action) => ({
   ...state,
   [action.key]: action.value,
});

const Section = (props) => {
   const [settings, dispatch] = useReducer(settingsReducer, undefined, readSettingsState);
   const updateSetting = useCallback((key, value) => {
      setCache(key, value);
      dispatch({key, value});
   }, []);

   const handleColorChange = useCallback((id) => updateSetting('material_color', id), [updateSetting]);
   const handleSolidChange = useCallback((solid) => updateSetting('solid', solid), [updateSetting]);
   const handleGradientChange = useCallback((gradient) => updateSetting('gradient', gradient), [updateSetting]);
   const handleComplementChange = useCallback((complement) => updateSetting('complement', complement), [updateSetting]);
   const handleSplitChange = useCallback((split) => updateSetting('split', split), [updateSetting]);
   const handleAnalogousChange = useCallback((analogous) => updateSetting('analogous', analogous), [updateSetting]);
   const handleTriadicChange = useCallback((triadic) => updateSetting('triadic', triadic), [updateSetting]);
   const handleTetradicChange = useCallback((tetradic) => updateSetting('tetradic', tetradic), [updateSetting]);
   const handleSolGradChange = useCallback((solgrad) => updateSetting('solgrad', solgrad), [updateSetting]);
   const handleExtractionChange = useCallback((extraction) => updateSetting('extraction', extraction), [updateSetting]);
   const handleHarmonyChange = useCallback((harmony) => updateSetting('harmony', harmony), [updateSetting]);
   const handlePresetChange = useCallback((preset) => updateSetting('preset', preset), [updateSetting]);
   const handleExtractCountChange = useCallback((count) => updateSetting('extraction_count', count), [updateSetting]);

   /** Extract swatch colors */
   const [swatch, setSwatch] = useState({ path: '', swatches: [] });
   const handleSwatchChange = (swatch) => setSwatch(swatch);

   /** Extract palette colors */
   const [palette, setPalette] = useState({ path: '', palette: [] });
   const handlePaletteChange = (palette) => setPalette(palette);

   /** Extract manual colors */
   const [manual, setManual] = useState({ path: '', rgb: { red: 0, green: 0, blue: 0 } });
   const handleManualChange = (palette) => setManual(palette);

   return (
      <section>
         <Header version={props.version} darkMode={props.darkMode} changeTheme={props.changeTheme} />
         {props.activeMenu === 1 && <MaterialColor activeColor={settings.material_color} darkMode={props.darkMode} changeColor={handleColorChange}/>}
         {props.activeMenu === 2 &&
             <Create darkMode={props.darkMode} solid={settings.solid} gradient={settings.gradient} changeSolid={handleSolidChange} changeGradient={handleGradientChange}/>}
         {props.activeMenu === 3 &&
             <Extract darkMode={props.darkMode} swatch={swatch} palette={palette} manual={manual} changeSwatch={handleSwatchChange} changePalette={handlePaletteChange}
                      changeManual={handleManualChange} extractionCount={settings.extraction_count}/>}
         {props.activeMenu === 4 && (
            <Harmonize
               darkMode={props.darkMode}
               complement={settings.complement}
               changeComplement={handleComplementChange}
               split={settings.split}
               changeSplit={handleSplitChange}
               analogous={settings.analogous}
               changeAnalogous={handleAnalogousChange}
               triadic={settings.triadic}
               changeTriadic={handleTriadicChange}
               tetradic={settings.tetradic}
               changeTetradic={handleTetradicChange}
            />
         )}
         {props.activeMenu === 5 && <Saved darkMode={props.darkMode} solgrad={settings.solgrad} changeSolGrad={handleSolGradChange} extraction={settings.extraction}
                                           changeExtraction={handleExtractionChange} harmony={settings.harmony} changeHarmony={handleHarmonyChange} preset={settings.preset}
                                           changePreset={handlePresetChange}/>}
         <Footer darkMode={props.darkMode} />
         {props.showSettings &&
             <Settings darkMode={props.darkMode} changeTheme={props.changeTheme} version={props.version} showModal={props.showModal} extractionCount={settings.extraction_count}
                       changeExtractionCount={handleExtractCountChange}/>}
      </section>
   );
};

export default Section;
